import { render } from "./MainList.vue?vue&type=template&id=4bdfeeee"
import script from "./MainList.vue?vue&type=script&lang=js"
export * from "./MainList.vue?vue&type=script&lang=js"

import "./MainList.vue?vue&type=style&index=0&id=4bdfeeee&lang=css"

import exportComponent from "/Users/baldo/Code/smileandlearn/demo-reading/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__